module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('swiper', {
    attrs: {
      "items": _vm.items
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351cd32c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/test.vue
// module id = 316
// module chunks = 1